import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    form: {
      description: 'Description (optional)',
      name: 'Name',
      price: 'Unit price excluding VAT',
      type: 'Type',
      vat: 'VAT',
    },
    save: 'Save item',
  },
  fr: {
    form: {
      description: 'Description (optionnelle)',
      name: 'Nom',
      price: 'Prix unitaire HT',
      type: 'Type',
      vat: 'TVA',
    },
    save: 'Enregistrer l’article',
  },
} as const);
